module.exports = __webpack_public_path__ + "static/media/main_300.72a0aaf5.ico";